import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Stack,
  Paper,
  CircularProgress,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ENDPOINT, IMAGE_BASE_URL } from "../../../endpoints/endpoints";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HighLightUpdate = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    name: "",
    category:"",
    video_url:""
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  const [categorys, setcategorys] = useState([]);
  const [categorySearch, setcategorySearch] = useState("");
  const [filteredcategorys,setfilteredcategory] = useState([]);
  const token = localStorage.getItem("accessToken");

  // ============================================
  // Fetch highlight Detail
  // ============================================
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      toast.warning("Please log in first!");
      navigate("/login");
      return;
    }

    const fetchhighlight = async () => {
      try {
        const res = await axios.get(ENDPOINT.HIGHLIGHT_DETAIL(id), {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = res.data.data; // ✔ correct backend key

        setFormData({
          name: data.name,
          video_url: data.video_url,
          category: data.category.id,
        });

        setPreview(`${IMAGE_BASE_URL}${data.image}`);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load highlight");
      } finally {
        setLoading(false);
      }
    };

    fetchhighlight();
    fetchAllCategory();
  }, [id, navigate]);


  const fetchAllCategory = async () => {
      try {
        let url = ENDPOINT.HIGHLIGHTCATEGORY_LIST;
        let allResults = [];
  
        while (url) {
          const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
          });
  
          allResults = [...allResults, ...res.data.results];
          url = res.data.next; // load next pages
        }
  
        setcategorys(allResults);
        setfilteredcategory(allResults)
      } catch (error) {
        console.error("Error loading category list:", error);
        toast.error("Failed to load categorys");
      }
    };
  
    useEffect(()=>{
    let filteredcategory = categorys.filter((l) =>
      l.name.toLowerCase().includes(categorySearch.toLowerCase())
    );
    setfilteredcategory(filteredcategory)
    },[categorySearch])

  const handleChange = (e) => {
    setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

    const handleFile = (file) => {
      if (file && file.type.startsWith("image/")) {
        setImage(file);
        setPreview(URL.createObjectURL(file));
      } else {
        toast.error("Please upload a valid image file!");
      }
    };
  
    const handleImageChange = (e) => handleFile(e.target.files[0]);
  
    const handleDragOver = (e) => {
      e.preventDefault();
      setDragActive(true);
    };
  
    const handleDragLeave = (e) => {
      e.preventDefault();
      setDragActive(false);
    };
  
    const handleDrop = (e) => {
      e.preventDefault();
      setDragActive(false);
      handleFile(e.dataTransfer.files[0]);
    };

  // ============================================
  // UPDATE Submit
  // ============================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const token = localStorage.getItem("accessToken");

     const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      if (image) {
        data.append("image", image);
      }

      const res = await axios.put(ENDPOINT.HIGHLIGHT_UPDATE(id), data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("highlight updated successfully");

      setTimeout(() => navigate(`/highlight/${id}`), 1200);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update highlight");
    } finally {
      setSaving(false);
    }
  };

  // ============================================
  // LOADING Spinner
  // ============================================
  if (loading) {
    return (
      <Box display="flex" height="80vh" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );
  }

  // ============================================
  // UI
  // ============================================
  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <ToastContainer />

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={3}>
          ✏️ Update HighLight 
        </Typography>

        <form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            {/* Name */}
            <TextField
              label="highlight Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <FormControl fullWidth>
              <InputLabel id="category-label">category</InputLabel>

              <Select
                labelId="category-label"
                label="category"
                name="category_id"
                value={formData.category}
                onChange={handleChange}
                required
                MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
              >
                {/* Search Box */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    placeholder="Search category..."
                    size="small"
                    value={categorySearch}
                    onChange={(e) => setcategorySearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()} 
                  />
                </MenuItem>

                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {filteredcategorys.length} results
                  </Typography>
                </MenuItem>

                {filteredcategorys.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {c.name}
                    </Box>
                  </MenuItem>
                ))}

                {filteredcategorys.length === 0 && (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

            {/* Image Upload */}
            <Box
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              sx={{
                border: dragActive ? "2px dashed #1976d2" : "2px dashed #ccc",
                borderRadius: 2,
                p: 3,
                textAlign: "center",
                backgroundColor: dragActive ? "#f0f7ff" : "#fafafa",
                cursor: "pointer",
                transition: "0.2s",
              }}
              onClick={() => document.getElementById("fileInput").click()}
            >
              {preview ? (
                <Box>
                  <Box
                    component="img"
                    src={preview}
                    alt="Preview"
                    sx={{
                      width: 200,
                      height: 200,
                      objectFit: "cover",
                      borderRadius: 2,
                      border: "1px solid #ddd",
                    }}
                  />
                  <Typography variant="body2" mt={1}>
                    Click or drop a new image to replace
                  </Typography>
                </Box>
              ) : (
                <Typography variant="body1" color="text.secondary">
                  Drag & drop image here, or click to select
                </Typography>
              )}

              <input
                id="fileInput"
                type="file"
                hidden
                accept="image/*"
                onChange={handleImageChange}
              />
            </Box>

             <TextField
                label="Video URL"
                name="video_url"
                value={formData.video_url}
                onChange={handleChange}
                fullWidth
                required
              />

            {/* BUTTONS */}
            <Stack direction="row" justifyContent="space-between">
              <Button variant="outlined" onClick={() => navigate(`/highlight/${id}`)}>
                Cancel
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={saving}
                sx={{ px: 4 }}
              >
                {saving ? <CircularProgress size={24} /> : "Update highlight"}
              </Button>
            </Stack>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
};

export default HighLightUpdate;
